import React from 'react'

const AlertMessage = (props) =>{
    if (!props.type || !props.message) return null
    return (

        <div id="alert-main" className='ml-5 mr-5'> 
            <div id="error-handler" className={"alert alert-"+props.type} role="alert">
                {props.message}
            </div>
        </div>
    )
}

export default AlertMessage